module.exports = __webpack_public_path__ + "img/file-drop-icon.0febb173.svg";